var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.youTubeURL
    ? _c("div", { staticClass: "tv-tab" }, [
        _vm.videoText
          ? _c("div", { staticClass: "tv-tab__text" }, [
              _c("p", { domProps: { innerHTML: _vm._s(_vm.videoText) } })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "tv-tab__video-container" }, [
          _c("iframe", {
            attrs: {
              frameborder: "0",
              scrolling: "no",
              marginheight: "0",
              marginwidth: "0",
              width: "100%",
              height: "275",
              type: "text/html",
              src:
                "https://www.youtube.com/embed/" +
                _vm.youTubeURL +
                "?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
            }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }